import { Callout, ExternalLink } from "@octopusdeploy/design-system-components";
import type * as React from "react";
import { UnstructuredFormSection } from "~/components/form";
import { TentacleCalloutHeading } from "./TentacleCalloutHeading";
export const LinuxListeningTentacleCallout: React.FC<{
    thumbprint: React.ReactNode;
}> = ({ thumbprint }) => (<UnstructuredFormSection stretchContent={true}>
        <Callout type={"information"} title={"Installation Instructions"}>
            <TentacleCalloutHeading />
            <div>
                <p>
                    For getting started instructions please visit the <ExternalLink href="LinuxListeningTentacle">Linux Tentacle documentation</ExternalLink>.
                </p>
                {thumbprint}
            </div>
        </Callout>
    </UnstructuredFormSection>);
LinuxListeningTentacleCallout.displayName = "LinuxListeningTentacleCallout"
export default LinuxListeningTentacleCallout;
